module.exports = __webpack_public_path__ + "static/media/Hot_Pumpkin.3ee5c7bc.webp";